import { useState, useEffect } from "react";
import { connect } from "react-redux";
import { SubmitButton } from "../../../lib/Button";
import { TableColumn, TableWithCollapse } from "../../../lib/DataTable";
import { useTableWithCollapse } from "../../../lib/DataTable/customHooks";
import { fetchInvestorDetails } from "../../../store/actions/nct";
import { RootStateType } from "../../../store/reducers";
import { LIST_PROTFOLIO_PAYLOAD } from "../../../store/types/portfolio";
import {
  EQUITY,
  LIQUID,
  DEBT,
  OTHER,
  DATA_ERROR,
} from "../../../utils/constants";
import { ConsolidateTableRowType } from "../ConsolidationFolios/types";
import NoFoliosFound from "../NoFoliosFound";
import { ActionHeader, BackArrow } from "../UpdateNominee/SelectedFolios";
import {
  getInvestorFunds,
  transactionSourceScenarioEmpty,
} from "../portfolios/utils";
import en from "../../../lang/en-us";
import { MenuItem } from "@material-ui/core";
import CustomizedSelect from "../transactions/customizedSelect";
import { useMobileEmailFilter } from "../useMobileEmailFilter";
import { groupFilteredData } from "../utils";

const { dashboard } = en;

export const CorrectionFolioColumns: TableColumn[] = [
  {
    field: "id",
    headerName: "FOLIO",
  },
  {
    field: "amcName",
    headerName: "Fund House",
    width: 250,
    filterBy: true,
    filterHeader: "Fund House",
    filterKey: "amcName",
  },
  {
    field: "bank",
    headerName: "BANK NAME",
    valueGetter: ({ row }) => row.banks[0]?.name || "Not Available",
    width: 200,
  },
  {
    field: "ifsc",
    headerName: "IFSC",
    valueGetter: ({ row }) => row.banks[0]?.ifsc || "Not Available",
    width: 200,
  },
  {
    field: "investorName",
    headerName: "PRIMARY HOLDER",
    valueGetter: ({ row }) =>
      (row?.investorName || "").toUpperCase() || "Not Available",
    width: 100,
  },
  {
    isFilter: true,
    field: "assetType",
    headerName: "Category",
    filterBy: true,
    renderStaticFilters: [EQUITY, LIQUID, DEBT, OTHER],
  },
];

function CorrectionFolios(props: any) {
  const [rowData, setRowData] = useState<ConsolidateTableRowType[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const { filterState, setGroupFilterMap, filterDispatch } =
    useMobileEmailFilter(rowData);
  const { emailMobileKeys, currentKey, groupedFilterMap } = filterState;
  const { selectedRows, setSelectedRows, tableRows, tableColumns, ...filters } =
    useTableWithCollapse<ConsolidateTableRowType[]>({
      rows: currentKey ? groupedFilterMap[currentKey] : rowData,
      columns: CorrectionFolioColumns,
      loading,
    });

  useEffect(() => {
    async function callApi() {
      try {
        const payload = {
          pan: props.investorData.PAN,
          brokercode: props.token,
        };
        const { body: investorDetails = {} } = await props.fetchInvestorDetails(
          payload
        );
        const { success: correctionFolios = [] } = investorDetails;
        const correctionFoliosRowData = getInvestorFunds(correctionFolios, [
          transactionSourceScenarioEmpty,
        ]);
        setRowData(correctionFoliosRowData);
        setLoading(false);
      } catch (err: any) {
        alert(err.message);
      }
    }
    callApi();
    return () => {};
  }, []);

  const handleFilterKeyChange = (e: any) => {
    filterDispatch({
      type: "SET_FILTER_KEY",
      payload: e.target.value,
    });
  };

  useEffect(() => {
    if (rowData.length > 0) {
      const groupedFilterMap = groupFilteredData(rowData);
      setGroupFilterMap(groupedFilterMap);
    }
  }, [rowData]);

  const _handleNext = () => {
    props.history.push("correction-folios-selection", {
      fund: selectedRows[0],
    });
  };

  return (
    <div className="curved-bg">
      {/* <PanSeedCheckNew */}
      {/*   foliosArray={selectedRows} */}
      {/*   callBackFn={_handleNext} */}
      {/*   trxnType={NFT_TRXN_TYPE_MAP.correctionOfErroneousData} */}
      {/*   goBack={false} */}
      {/*   triggerCheck={callPanSeed} */}
      {/*   resetTrigger={resetTrigger} */}
      {/* /> */}
      <BackArrow history={props.history} />
      <div className="curved-bg-content">
        <h5 style={{ marginLeft: "10px" }}>
          Correction of erroneous data captured in Folio
        </h5>
        {rowData.length > 0 && currentKey && (
          <div
            className="appbar-div dual-margin input-name-responsive"
            style={{ display: "flex", gap: "1%" }}
          >
            <div
              className="input-name input-name-sizing-responsive"
              style={{
                alignItems: "center",
                display: "flex",
                marginBottom: "0",
              }}
            >
              Select Email-Mobile Combination
            </div>
            <CustomizedSelect
              handleChange={handleFilterKeyChange}
              value={currentKey}
              emailStyle={true}
            >
              {emailMobileKeys &&
                emailMobileKeys.map((item) => (
                  <MenuItem value={item} key={item}>
                    {item}
                  </MenuItem>
                ))}
            </CustomizedSelect>
          </div>
        )}
      </div>
      <div className="curved-bg-content curved-bg-table-outer">
        <div className="curved-bg-content-table">
          <h5 style={{ marginLeft: "10px" }}>
            {" "}
            {dashboard.CorrectionFolios.CorrectionFoliosInfo}
          </h5>
          <div className="curved-table-content">
            {!!tableRows.length && currentKey ? (
              <TableWithCollapse
                rows={tableRows}
                columns={tableColumns}
                setSelectedRows={setSelectedRows}
                selectedRows={selectedRows}
                radioGroupsEnabled
                {...filters}
              />
            ) : (
              <NoFoliosFound />
            )}
          </div>
          {/* <FaqLink section={DATA_ERROR} history={props.history} /> */}
        </div>
        <div className="curved-bg-content-inner-bottom">
          {!!rowData.length && (
            <div className="table-submit">
              <SubmitButton
                disabled={!selectedRows.length}
                className="customBtn"
                label={dashboard.CorrectionFolios.buttonText}
                onClick={_handleNext}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default connect(
  ({ authReducer }: RootStateType) => ({ ...authReducer }),
  {
    fetchInvestorDetails,
  }
)(CorrectionFolios);
